<div class="vp-search">
  <i class="vp-search-icon mynaui-search" aria-hidden="true"></i>

  <input
    #queryInput
    class="vp-search-input"
    type="text"
    [value]="query()"
    [placeholder]="placeholder()"
    [attr.aria-label]="placeholder()"
    (input)="onInput($event)" />

  @if (active()) {
    <span class="vp-search-count" [class.has-clear]="query()">{{ count() }}</span>
  }

  @if (query()) {
    <button type="button" class="vp-search-clear" aria-label="Clear search" (click)="clear()">
      <i class="mynaui-x" aria-hidden="true"></i>
    </button>
  }
</div>
